import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaMoon, FaSun, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import logo from '../../Assets/carrerup_allInOne_cover_NoBg.png';

const Navbar = () => {
  const navigate = useNavigate();
  const [showLanguages, setShowLanguages] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLightMode, setIsLightMode] = useState(() => localStorage.getItem('carrerupWebsiteTheme') === 'light');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.body.classList.toggle('wb-light-mode', isLightMode);
    localStorage.setItem('carrerupWebsiteTheme', isLightMode ? 'light' : 'dark');

    return () => document.body.classList.remove('wb-light-mode');
  }, [isLightMode]);

  const languageFlags = { fr: '🇫🇷', en: '🇬🇧', ar: '🇲🇦', es: '🇪🇸', pt: '🇵🇹', zh: '🇨🇳', de: '🇩🇪', ru: '🇷🇺', it: '🇮🇹', sr: '🇷🇸' };
  const closeMenu = () => setIsMenuOpen(false);
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('siteLanguage', lang);
    setShowLanguages(false);
  };

  const navItems = [
    ['first-div', 'home'], ['second-div', 'ecosystem'], ['third-div', 'process'],
    ['fourth-div', 'features'], ['pricing', 'pricing'], ['sixth-div', 'contact']
  ];

  return (
    <header className={`wb-wcm-header ${isMenuOpen ? 'wb-menu-open' : ''}`}>
      <div className="wb-nav-brand" onClick={() => navigate('/')} role="button" tabIndex={0}>
        <img src={logo} alt="CarrerUp" className="navbar-logo" />
        <span className="wb-brand-meta"><b>SPORT</b> INTELLIGENCE</span>
      </div>

      <nav className={`wb-wcm-nav ${isMenuOpen ? 'wb-responsive-nav' : ''}`} aria-label="Navigation principale">
        <button className="wb-nav-close-btn" onClick={closeMenu} aria-label="Fermer le menu"><FaTimes /></button>
        <span className="wb-nav-mobile-label">EXPLORE CARRERUP</span>
        <ul>
          {navItems.map(([target, label], index) => (
            <li key={target} style={{ '--item': index }}>
              <Link to={target} smooth duration={600} offset={target === 'pricing' ? -100 : 0} onClick={closeMenu}>{label === 'pricing' ? ({ fr: 'Tarifs', en: 'Pricing', es: 'Precios', ar: 'الأسعار' }[(i18n.resolvedLanguage || i18n.language).split('-')[0]] || 'Pricing') : t(label)}</Link>
            </li>
          ))}
        </ul>
        <div className="wb-nav-mobile-actions">
          <button className="wb-login-btn" onClick={() => navigate('/login')}>{t('login')}</button>
          <button className="wb-register-btn" onClick={() => navigate('/register')}>{t('register')}</button>
        </div>
      </nav>

      <div className="navbar-right">
        <button
          className="wb-theme-btn"
          onClick={() => setIsLightMode((value) => !value)}
          aria-label={isLightMode ? 'Activer le mode sombre' : 'Activer le mode clair'}
          title={isLightMode ? 'Mode sombre' : 'Mode clair'}
        >
          {isLightMode ? <FaMoon /> : <FaSun />}
        </button>
        <div className="language-container">
          <button className="language-btn" onClick={() => setShowLanguages(!showLanguages)} aria-label="Choisir la langue">
            <span className="active-language-flag">{languageFlags[i18n.language] || '🇫🇷'}</span>
          </button>
          {showLanguages && (
            <div className="language-dropdown">
              <button onClick={() => changeLanguage('fr')}>🇫🇷 Français</button>
              <button onClick={() => changeLanguage('en')}>🇬🇧 English</button>
              <button onClick={() => changeLanguage('ar')}>🇲🇦 العربية</button>
              <button onClick={() => changeLanguage('es')}>🇪🇸 Español</button>
              <button onClick={() => changeLanguage('pt')}>🇵🇹 Português</button>
              <button onClick={() => changeLanguage('zh')}>🇨🇳 中文（简体）</button>
              <button onClick={() => changeLanguage('de')}>🇩🇪 Deutsch</button>
              <button onClick={() => changeLanguage('ru')}>🇷🇺 Русский</button>
              <button onClick={() => changeLanguage('it')}>🇮🇹 Italiano</button>
              <button onClick={() => changeLanguage('sr')}>🇷🇸 Srpski</button>
            </div>
          )}
        </div>
        <button className="wb-login-btn wb-desktop-action" onClick={() => navigate('/login')}>{t('login')}</button>
        <button className="wb-register-btn wb-desktop-action" onClick={() => navigate('/register')}>{t('register')}</button>
        <button className="wb-nav-btn" onClick={() => setIsMenuOpen(true)} aria-label="Ouvrir le menu"><FaBars /></button>
      </div>
    </header>
  );
};

export default Navbar;
